import React from "react";
import { useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { USER_MANAGEMENT_URL } from "../Shared/constant";
import moment from "moment";

const UserView = () => {
  const { CurrenUrlBaseForOrder } = useSelector((state) => state.orderReducers);
  const { userList } = useSelector((state) => state.userReducers);

  const Navigate = useNavigate();
  const onClick = () => {
    Navigate(USER_MANAGEMENT_URL);
  };
  const param = useParams();
  const matchData = userList?.find((user) => user?.id === param?.id);

  return (
    <>
      <ul className="tabcomnsection">
        {CurrenUrlBaseForOrder === "view-package" ? (
          <li
            className={CurrenUrlBaseForOrder === "view-package" ? "active" : ""}
          >
            User
          </li>
        ) : (
          <>User</>
        )}
        <div className="tabheadebuttns">
          <div className="btn savchanges linksmanage" onClick={onClick}>
            Back
          </div>
        </div>
      </ul>
      <div className="row">
        <div className="col-md-6">
          <h2 className="userview_head">User Details :</h2>
          <ul className="list_who_wrapper">
            <li>
              <label>User Name: </label>
              {matchData?.first_name || "-"}
            </li>
            {/* <li>
              <label>Last Name: </label>
              {matchData?.last_name || "-"}
            </li> */}
            <li>
              <label>Email: </label>
              {matchData?.email || "-"}
            </li>
            <li>
              <label>Phone: </label>
              {matchData?.phone || "-"}
            </li>
            <li>
              <label>Registered At: </label>
              {moment(matchData?.created_at).format("LL") || "-"}
            </li>
          </ul>
        </div>
        <div className="col-md-6">
          <h2 className="userview_head">Bank Details :</h2>
          <ul className="list_who_wrapper">
            <li className="text-capitalized">
              <label>Account Holder Name: </label>
              {matchData?.bank_details?.holder_name || "-"}
            </li>
            <li className="text-capitalized">
              <label>Account number: </label>
              {matchData?.bank_details?.ac_number || "-"}
            </li>
            <li className="text-capitalized">
              <label>Routing number: </label>
              {matchData?.bank_details?.ac_routing || "-"}
            </li>
            <li className="text-capitalized">
              <label>Account Type: </label>
              {matchData?.bank_details?.ac_type || "-"}
            </li>
            <li className="text-capitalized">
              <label>Account Phone Number: </label>
              {matchData?.bank_details?.ac_phone_no || "-"}
            </li>
            <li className="text-capitalized">
              <label>Payout Method: </label>
              {matchData?.bank_details?.method || "-"}
            </li>
            <li className="text-capitalized">
              <label>Address: </label>
              {matchData?.bank_details?.address || "-"}
            </li>
          </ul>
        </div>
      </div>
    </>
  );
};
export default UserView;
